module.exports = __webpack_public_path__ + "img/1_019.0a9a04db.jpg";